import React, { useRef, useState, useEffect } from 'react';
import { useOrderContext } from '../../components/Context/OrderContext';
import OrderTable from '../../views/AdminView/OrderTable';



const OrderCompoent = () => {

    const data = useRef('');
    const [loading, setLoading] = useState(true);
    const didFetch = useRef(false);

    const error = useRef('');
    const { FetchOrders,orders,partnerOrders,FetchPartnerOrders } = useOrderContext();
    const userType = localStorage.getItem('userType'); 
    const getData = async () => {

        try {
            // Fetch data based on userType
            if (userType === 'ADMIN') {
                await FetchOrders(); // Load admin orders
            } else if (userType === 'PARTNER' || userType === 'EMPLOYEE') {
                await FetchPartnerOrders(); // Load partner/employee orders
            }
            setLoading(false); 
        } catch (err) {
            console.error('Error fetching data:', err);
            error.current = 'Failed to fetch data.';
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!didFetch.current) {debugger;
            getData();
            didFetch.current = true; // Mark the API call as done
        }
    });

    return (
        <div>{ !loading && <OrderTable />}</div>
            
      
    )

};

export default OrderCompoent;
